import React from 'react';

interface AutocompleteFormatGefahrgutklasseProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatGefahrgutklasse = ({
  suchvorschlag,
}: AutocompleteFormatGefahrgutklasseProps) => {
  return (
    suchvorschlag && (
      <span>
        {suchvorschlag[`bezeichnung`]} - {suchvorschlag[`version`]} -{' '}
        {suchvorschlag[`unnr`]} - {suchvorschlag['verpackungscode']} -{' '}
        {suchvorschlag['klassifizierung']} - {suchvorschlag['klasse']}
      </span>
    )
  );
};
